import { Certificate, CrewMember } from '@legacy-types';

import { useData } from '@shared/api/hooks/useData';
import { CertificatesDataTable } from '@shared/certificates/components/CertificatesDataTable/CertificatesDataTable';
import { getCertificates } from '@shared/certificates/endpoints/getCertificates';
import { Portlet } from '@shared/ui/components/Portlet';

type ShowUserRegistrationCertificatesProps = {
  crewMember: CrewMember;
};

export function ShowUserRegistrationCertificates({ crewMember }: ShowUserRegistrationCertificatesProps) {
  const certificates = useData<Certificate>({
    get: getCertificates,
    defaults: { sort: '-updated_at' },
    query: { filter: { user_id: crewMember.userId }, page: { size: 100 } },
    history: false,
  });

  return (
    <Portlet title="Certificates">
      <CertificatesDataTable
        columns={{ employee: false }}
        certificates={certificates}
        admin
        avoidPagination
        withoutFilters
      />
    </Portlet>
  );
}
